import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Box, Tab, Tabs } from "@mui/material";

import {
  PasswordMisuseSourceParams,
  PasswordMisuseTab,
} from "@/pages/browser-defender/demo/passwordMisuseUpdated/service/types";

type PasswordMisuseTabsProps = {
  onChange: (props: PasswordMisuseSourceParams) => void;
  activeTab?: PasswordMisuseTab;
};

const PasswordMisuseTabs = ({
  onChange,
  activeTab: externalActiveTab,
}: PasswordMisuseTabsProps) => {
  const [internalActiveTab, setInternalActiveTab] =
    useState<PasswordMisuseTab>("phishing");
  const { t } = useTranslation();

  const activeTab = externalActiveTab || internalActiveTab;

  const handleTabChange = (newTab: PasswordMisuseTab) => {
    setInternalActiveTab(newTab);

    switch (newTab) {
      case "phishing":
        onChange({
          tab: "phishing",
        });
        break;
      case "reuse":
        onChange({
          tab: "reuse",
        });
        break;
      case "archived":
        onChange({
          tab: "archived",
        });
        break;
      default:
        throw new Error("Invalid tab");
    }
  };

  return (
    <Box sx={{ width: "100%", borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={activeTab}
        onChange={(_, nextTab) => handleTabChange(nextTab)}
        sx={{
          minHeight: "45px",
          height: "45px",
          "& .MuiTab-root": {
            fontWeight: 600,
            textTransform: "uppercase",
            fontSize: "0.85rem",
            minWidth: "150px",
            letterSpacing: "0.5px",
          },
          "& .Mui-selected": {
            color: "#1976d2",
            fontWeight: 700,
          },
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: "#1976d2",
            height: 3,
          },
        }}
      >
        <Tab disableRipple label={t("PHISHING ALERTS")} value="phishing" />
        <Tab disableRipple label={t("REUSE ALERTS")} value="reuse" />
        <Tab disableRipple label={t("ARCHIVED ALERTS")} value="archived" />
      </Tabs>
    </Box>
  );
};

export default PasswordMisuseTabs;
